import { render, staticRenderFns } from "./ResearchMap.vue?vue&type=template&id=2530f690&scoped=true&"
import script from "./ResearchMap.vue?vue&type=script&lang=js&"
export * from "./ResearchMap.vue?vue&type=script&lang=js&"
import style0 from "./ResearchMap.vue?vue&type=style&index=0&id=2530f690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530f690",
  null
  
)

export default component.exports